export enum TypesParametreEnum {
  JSON = "JSON",
  stringlist = "Liste de phrases",
  String = "Phrase",
  text = "Texte",
}